import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useAuth } from 'components/Auth'
import useReturnToPage from 'hooks/useReturnToPage'
import { useSelector } from 'react-redux'
import { getUser } from 'store/selectors'
import { User } from 'types'

function RedirectPage() {
  const { authenticated } = useAuth()
  const user = useSelector(getUser) as User
  const navigate = useNavigate()
  const { getLocationToReturnTo } = useReturnToPage()
  const userId = user?.id

  useEffect(() => {
    if (authenticated && userId) {
      const returnToLocation = getLocationToReturnTo().replace('/tools', '')
      navigate(returnToLocation, { replace: true })
    }
  }, [userId])

  return null
}

export default RedirectPage
